'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Host$() {
  this.c7G = null;
  this.c7H = false;
  this.c7E = null;
  this.c7F = false;
  this.c7K = null;
  this.c7L = false;
  this.c7I = null;
  this.c7J = false;
  this.c7O = null;
  this.c7M = null;
  this.c7N = false;
  $n_Lpresto_types$Host$ = this;
  this.c7O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "^(?=.{1,255}$)(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\\.[A-Za-z0-9-]{1,63})*$", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
}
export { $c_Lpresto_types$Host$ as $c_Lpresto_types$Host$ };
$p = $c_Lpresto_types$Host$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$;
/** @constructor */
function $h_Lpresto_types$Host$() {
}
export { $h_Lpresto_types$Host$ as $h_Lpresto_types$Host$ };
$h_Lpresto_types$Host$.prototype = $p;
$p.cs3 = (function() {
  if ((!this.c7H)) {
    this.c7G = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c7H = true;
  }
  return this.c7G;
});
$p.v9 = (function() {
  if ((!this.c7F)) {
    this.c7E = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c7F = true;
  }
  return this.c7E;
});
$p.a2G = (function() {
  if ((!this.c7L)) {
    this.c7K = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7L = true;
  }
  return this.c7K;
});
$p.adC = (function() {
  if ((!this.c7J)) {
    this.c7I = new $c_Lpresto_types$Host$$anon$75(this);
    this.c7J = true;
  }
  return this.c7I;
});
$p.a2L = (function() {
  if ((!this.c7N)) {
    this.c7M = new $c_Lpresto_types$Host$$anon$76(this);
    this.c7N = true;
  }
  return this.c7M;
});
$p.a2Z = (function(str) {
  return (((str.indexOf(".") | 0) !== (-1)) && this.c7O.aeg(str));
});
var $d_Lpresto_types$Host$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$, "presto.types$Host$", ({
  a0q: 1,
  D: 1
}));
export { $d_Lpresto_types$Host$ as $d_Lpresto_types$Host$ };
var $n_Lpresto_types$Host$;
function $m_Lpresto_types$Host$() {
  if ((!$n_Lpresto_types$Host$)) {
    $n_Lpresto_types$Host$ = new $c_Lpresto_types$Host$();
  }
  return $n_Lpresto_types$Host$;
}
export { $m_Lpresto_types$Host$ as $m_Lpresto_types$Host$ };
/** @constructor */
function $c_Lpresto_types$Host$$anon$76(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Host$$anon$76 as $c_Lpresto_types$Host$$anon$76 };
$p = $c_Lpresto_types$Host$$anon$76.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$$anon$76;
/** @constructor */
function $h_Lpresto_types$Host$$anon$76() {
}
export { $h_Lpresto_types$Host$$anon$76 as $h_Lpresto_types$Host$$anon$76 };
$h_Lpresto_types$Host$$anon$76.prototype = $p;
$p.bn = (function(it) {
  try {
    $m_Lpresto_types$Host$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return ($m_Lpresto_types$Host$().a2Z(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "Host inv\u00e1lido")));
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Host$$anon$76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$$anon$76, "presto.types$Host$$anon$76", ({
  a0s: 1,
  K: 1
}));
export { $d_Lpresto_types$Host$$anon$76 as $d_Lpresto_types$Host$$anon$76 };
/** @constructor */
function $c_Lpresto_types$Host$$anon$75(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Host$$anon$75 as $c_Lpresto_types$Host$$anon$75 };
$p = $c_Lpresto_types$Host$$anon$75.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$$anon$75;
/** @constructor */
function $h_Lpresto_types$Host$$anon$75() {
}
export { $h_Lpresto_types$Host$$anon$75 as $h_Lpresto_types$Host$$anon$75 };
$h_Lpresto_types$Host$$anon$75.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$Host$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$Host$$anon$75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$$anon$75, "presto.types$Host$$anon$75", ({
  a0r: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$Host$$anon$75 as $d_Lpresto_types$Host$$anon$75 };
//# sourceMappingURL=presto.types$-Host$.js.map
